(() => {

  class CartDrawer {

    constructor() {

      this.selectors = {
        drawer: '#cart-drawer',
        overlay: '.cart-drawer-overlay',
        content: '.cart-drawer-content',
        cartCount: '.open-cart-drawer .numbber-cart',
        slider: '#Slider-ks-cart-upsells'
      };

      this.state = {
        isOpen: false,
        isLoading: false
      };

      this.queue = {};

      this.abortController = null;

      this.scrollPosition = 0;

      this.init();

    }

    /*
    ==================================================
    INIT
    ==================================================
    */

    init() {

      this.cache();

      this.bindEvents();

      this.initUpsellSlider();

    }

    cache() {

      this.drawer =
        document.querySelector(this.selectors.drawer);

      this.overlay =
        document.querySelector(this.selectors.overlay);

    }

    /*
    ==================================================
    OPEN
    ==================================================
    */

    open() {

      if (this.state.isOpen) return;

      this.state.isOpen = true;

      this.scrollPosition = window.scrollY;

      document.body.classList.add('cart-drawer-open');

      document.body.style.top =
        `-${this.scrollPosition}px`;

      requestAnimationFrame(() => {

        this.initUpsellSlider();

      });

    }

    /*
    ==================================================
    CLOSE
    ==================================================
    */

    close() {

      if (!this.state.isOpen) return;

      this.state.isOpen = false;

      document.body.classList.remove(
        'cart-drawer-open'
      );

      document.body.style.top = '';

      window.scrollTo(0, this.scrollPosition);

    }

    /*
    ==================================================
    LOADING
    ==================================================
    */

    setLoading(state = true) {

      this.state.isLoading = state;

      this.drawer?.classList.toggle(
        'is-loading',
        state
      );

    }

    /*
    ==================================================
    MESSAGE
    ==================================================
    */

    showMessage(message, type = 'error') {

      const old =
        this.drawer.querySelector(
          '.cart-drawer-message'
        );

      if (old) old.remove();

      const el = document.createElement('div');

      el.className =
        `cart-drawer-message is-${type}`;

      el.innerHTML = `<span>${message}</span>`;

      this.drawer.appendChild(el);

      requestAnimationFrame(() => {
        el.classList.add('is-visible');
      });

      setTimeout(() => {

        el.classList.remove('is-visible');

        setTimeout(() => {

          el.remove();

        }, 150);

      }, 3000);

    }

    /*
    ==================================================
    SECTION RENDER
    ==================================================
    */

    async renderSections() {

      const response = await fetch(
        '/?sections=cart-drawer',
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      const data = await response.json();

      if (!data['cart-drawer']) {
        throw new Error(
          'Section render failed'
        );
      }

      const temp = document.createElement('div');

      temp.innerHTML = data['cart-drawer'];

      const newContent =
        temp.querySelector(
          '.cart-drawer-content'
        );

      const currentContent =
        document.querySelector(
          '.cart-drawer-content'
        );

      if (
        newContent &&
        currentContent
      ) {
        currentContent.innerHTML =
          newContent.innerHTML;
      }

      this.initUpsellSlider();

    }

    /*
    ==================================================
    UPDATE CART COUNT
    ==================================================
    */

    updateCartCount(count) {

      document.querySelectorAll(
        this.selectors.cartCount
      ).forEach(el => {

        el.textContent = count;

      });

    }

    /*
    ==================================================
    ADD TO CART
    ==================================================
    */

    async addItem(form) {

      if (form.dataset.loading === 'true') {
        return;
      }

      form.dataset.loading = 'true';

      const button =
        form.querySelector(
          '[type="submit"]'
        );

      try {

        this.open();

        this.setLoading(true);

        if (button) {
          button.disabled = true;
        }

        const formData =
          new FormData(form);

        formData.append(
          'sections',
          'cart-drawer'
        );

        const response = await fetch(
          '/cart/add.js',
          {
            method:'POST',
            headers:{
              Accept:'application/json'
            },
            body:formData
          }
        );

        const data =
          await response.json();

        if (
          !response.ok ||
          data.status
        ) {

          throw new Error(
            data.description ||
            data.message ||
            'Add to cart failed'
          );

        }

        /*
        SECTION HTML
        */

        if (
          data.sections &&
          data.sections['cart-drawer']
        ) {

          const temp =
            document.createElement('div');

          temp.innerHTML =
            data.sections['cart-drawer'];

          const newContent =
            temp.querySelector(
              '.cart-drawer-content'
            );

          const currentContent =
            document.querySelector(
              '.cart-drawer-content'
            );

          if (
            newContent &&
            currentContent
          ) {

            currentContent.innerHTML =
              newContent.innerHTML;

          }

        } else {

          await this.renderSections();

        }

        /*
        COUNT
        */

        if (
          typeof data.item_count !==
          'undefined'
        ) {

          this.updateCartCount(
            data.item_count
          );

        }

        this.initUpsellSlider();

      } catch(error) {

        console.error(error);

        this.showMessage(
          error.message,
          'error'
        );

      } finally {

        this.setLoading(false);

        form.dataset.loading = 'false';

        if (button) {
          button.disabled = false;
        }

      }

    }

    /*
    ==================================================
    UPDATE ITEM
    ==================================================
    */

    queueUpdate(line, quantity) {

      clearTimeout(this.queue[line]);

      this.queue[line] =
        setTimeout(() => {

          this.updateItem(
            line,
            quantity
          );

        }, 150);

    }

    async updateItem(
      line,
      quantity
    ) {

      try {

        this.setLoading(true);

        /*
        ABORT OLD
        */

        if (
          this.abortController
        ) {

          this.abortController.abort();

        }

        this.abortController =
          new AbortController();

        const response =
          await fetch(
            '/cart/change.js',
            {
              method:'POST',
              headers:{
                'Content-Type':
                  'application/json',
                Accept:
                  'application/json'
              },
              signal:
                this.abortController.signal,
              body:JSON.stringify({
                line,
                quantity,
                sections:
                  'cart-drawer'
              })
            }
          );

        const data =
          await response.json();

        if (
          !response.ok ||
          data.status
        ) {

          throw new Error(
            data.description ||
            data.message ||
            'Cart update failed'
          );

        }

        /*
        UPDATE HTML
        */

        if (
          data.sections &&
          data.sections['cart-drawer']
        ) {

          const temp =
            document.createElement('div');

          temp.innerHTML =
            data.sections['cart-drawer'];

          const newContent =
            temp.querySelector(
              '.cart-drawer-content'
            );

          const currentContent =
            document.querySelector(
              '.cart-drawer-content'
            );

          if (
            newContent &&
            currentContent
          ) {

            currentContent.innerHTML =
              newContent.innerHTML;

          }

        } else {

          await this.renderSections();

        }

        this.updateCartCount(
          data.item_count || 0
        );

        this.initUpsellSlider();

      } catch(error) {

        if (
          error.name ===
          'AbortError'
        ) {
          return;
        }

        console.error(error);

        this.showMessage(
          error.message,
          'error'
        );

      } finally {

        this.setLoading(false);

      }

    }

    /*
    ==================================================
    REMOVE ITEM
    ==================================================
    */

    removeItem(line) {

      this.updateItem(line, 0);

    }

    /*
    ==================================================
    SLIDER
    ==================================================
    */

    initUpsellSlider() {

      if (
        typeof window.jQuery ===
        'undefined'
      ) {
        return;
      }

      const $slider =
        window.jQuery(
          this.selectors.slider
        );

      if (
        !$slider.length
      ) {
        return;
      }

      if (
        $slider.hasClass(
          'slick-initialized'
        )
      ) {

        $slider.slick(
          'setPosition'
        );

        return;

      }

      $slider.slick({
        slidesToShow:1,
        slidesToScroll:1,
        arrows:false,
        dots:true,
        infinite:false,
        adaptiveHeight:true,
        mobileFirst:true
      });

    }

    /*
    ==================================================
    EVENTS
    ==================================================
    */

    bindEvents() {

      /*
      OPEN
      */

      document.addEventListener(
        'click',
        e => {

          const trigger =
            e.target.closest(
              '.open-cart-drawer, .header__icon--cart, .cart-icon-bubble, [href="#CartDrawer"]'
            );

          if (!trigger) return;

          e.preventDefault();

          this.open();

        }
      );

      /*
      CLOSE
      */

      document.addEventListener(
        'click',
        e => {

          const trigger =
            e.target.closest(
              '.cart-drawer-overlay, #cart-drawer .close, #cart-drawer .btn--continue-shopping'
            );

          if (!trigger) return;

          this.close();

        }
      );

      /*
      ESC
      */

      document.addEventListener(
        'keydown',
        e => {

          if (
            e.key === 'Escape'
          ) {

            this.close();

          }

        }
      );

      /*
    ==================================================
    CHECKOUT
    ==================================================
    */

    document.addEventListener(
      'click',
      async e => {

        const btn = e.target.closest(
          '#cart-drawer .btn-checkout'
        );

        if (!btn) return;

        e.preventDefault();

        if (btn.dataset.loading === 'true') {
          return;
        }

        btn.dataset.loading = 'true';

        try {

          btn.disabled = true;

          /*
          Optional:
          sync latest cart before checkout
          */

          window.location.assign('/checkout');

        } finally {

          setTimeout(() => {

            btn.disabled = false;

            delete btn.dataset.loading;

          }, 500);

        }

      }
    );

      /*
      AJAX ADD TO CART
      */

      document.addEventListener(
        'submit',
        e => {

          const form =
            e.target.closest(
              'form[action*="/cart/add"]'
            );

          if (!form) return;

          /*
          IGNORE NATIVE
          */

          if (
            form.classList.contains(
              'product-purchase-form'
            ) ||
            form.querySelector(
              '.original-selector'
            )
          ) {
            return;
          }

          /*
          IGNORE MANUAL
          */

          if (
            form.hasAttribute(
              'data-no-ajax-cart'
            )
          ) {
            return;
          }

          e.preventDefault();

          this.addItem(form);

        }
      );

      /*
      REMOVE
      */

      document.addEventListener(
        'click',
        e => {

          const btn =
            e.target.closest(
              '.remove-item'
            );

          if (!btn) return;

          e.preventDefault();

          const input =
            document.querySelector(
              `.quantity-${btn.dataset.variant}`
            );

          if (!input) return;

          this.removeItem(
            input.dataset.line
          );

        }
      );

      /*
      QTY BUTTON
      */

      document.addEventListener(
        'click',
        e => {

          const btn =
            e.target.closest(
              '.qty-wrapper a'
            );

          if (!btn) return;

          e.preventDefault();

          const wrapper =
            btn.closest(
              '.qty-wrapper'
            );

          const input =
            wrapper.querySelector(
              '.quantity'
            );

          if (!input) return;

          let qty =
            parseInt(
              input.value
            ) || 0;

          if (
            btn.classList.contains(
              'plus'
            )
          ) {

            qty++;

          }

          if (
            btn.classList.contains(
              'minus'
            )
          ) {

            qty = Math.max(
              0,
              qty - 1
            );

          }

          input.value = qty;

          this.queueUpdate(
            input.dataset.line,
            qty
          );

        }
      );

      /*
      INPUT CHANGE
      */

      document.addEventListener(
        'change',
        e => {

          const input =
            e.target.closest(
              '.quantity'
            );

          if (!input) return;

          const qty =
            parseInt(
              input.value
            ) || 0;

          this.queueUpdate(
            input.dataset.line,
            qty
          );

        }
      );

    }

  }

  /*
  ==================================================
  INIT
  ==================================================
  */

  window.CartDrawer =
    new CartDrawer();

  window.openCartDrawer = () => {
    window.CartDrawer.open();
  };

  window.refreshCartDrawer = async () => {
    await window.CartDrawer.renderSections();
  };

  window.openAndRefreshCartDrawer = async () => {

    try {

      window.CartDrawer.renderSections();
      await window.CartDrawer.open();

      //window.CartDrawer.setLoading(true);

       

    } catch(error) {

      console.error('Cart refresh failed:', error);

    } finally {

      //window.CartDrawer.setLoading(false);

    }

  };

})();